export const filesAccepted =
  'video/*,image/*,.doc,.docx,.pdf,.txt,.rtf,.xls,.html,.ppt,.pptx';
